import apiService from '../utils/apiInterceptor';

const invoiceService = {
  listInvoices: async (params = {}) => {
    return await apiService.get('/invoices', { params });
  },
  listInvoiceableOrders: async (params = {}) => {
    return await apiService.get('/invoicing/orders', { params });
  },
  listAllInvoiceableOrders: async (params = {}) => {
    const perPage = 500;
    const rowsById = new Map();
    let page = 1;
    let lastPage = 1;

    do {
      const response = await apiService.get('/invoicing/orders', {
        params: { ...params, page, per_page: perPage },
      });
      const rows = response?.data || response || [];

      for (const row of (Array.isArray(rows) ? rows : [])) {
        const key = row?.id === null || row?.id === undefined
          ? `missing-id-${page}-${rowsById.size}`
          : String(row.id);
        if (!rowsById.has(key)) {
          rowsById.set(key, row);
        }
      }

      const pagination = response?.pagination || response?.meta;
      if (!pagination) {
        break;
      }

      const parsedLastPage = Number(pagination.last_page);
      lastPage = Number.isFinite(parsedLastPage) && parsedLastPage > 0
        ? parsedLastPage
        : page;
      page += 1;
    } while (page <= lastPage);

    return Array.from(rowsById.values());
  },
  createInvoice: async (payload) => {
    return await apiService.post('/invoices', payload);
  },
  updateInvoice: async (invoiceId, payload) => {
    return await apiService.put(`/invoices/${invoiceId}`, payload);
  },
  markInvoicePaid: async (invoiceId) => {
    return await apiService.post(`/invoices/${invoiceId}/mark-paid`);
  },
  revertInvoicePaid: async (invoiceId) => {
    return await apiService.post(`/invoices/${invoiceId}/revert-paid`);
  },
  deleteInvoice: async (invoiceId) => {
    return await apiService.delete(`/invoices/${invoiceId}`);
  },
  previewInvoice: async (invoiceId) => {
    // apiService returns response.data; ensure we get raw HTML string
    return await apiService.get(`/invoices/${invoiceId}/preview`, {
      responseType: 'text',
      headers: { Accept: 'text/html' },
    });
  },
  fetchInvoicePdf: async (invoiceId, { download = false, include_items = true } = {}) => {
    return await apiService.get(`/invoices/${invoiceId}/pdf`, {
      params: { download, include_items },
      responseType: 'blob',
    });
  },
  getSettings: async () => {
    return await apiService.get('/invoice-settings');
  },
  updateSettings: async (payload) => {
    return await apiService.post('/invoice-settings', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
};

export default invoiceService;
